/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationCreateDto } from '../../models/consultation-create-dto';
import { ConsultationDto } from '../../models/consultation-dto';

export interface ConsultationClientControllerCreateV1$Params {
      body: ConsultationCreateDto
}

export function consultationClientControllerCreateV1(http: HttpClient, rootUrl: string, params: ConsultationClientControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, consultationClientControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationDto>;
    })
  );
}

consultationClientControllerCreateV1.PATH = '/api/v1/consultations/client';
